import {
  combineReducers,
  configureStore as reduxConfigureStore
} from "@reduxjs/toolkit";

import type { Middleware } from "@reduxjs/toolkit";

import { reducers as rootReducer } from "../../../store/reducers";
import accountReducer from "../state/reducers";

const combined_reducers = combineReducers({
  ...rootReducer,
  ...accountReducer
});

export type AccountReduxState = ReturnType<typeof combined_reducers>;

export default function configureStore(
  INITIAL_STATE: {},
  middlewares: Middleware[] = []
) {
  return reduxConfigureStore({
    reducer: combined_reducers,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(middlewares),
    preloadedState: INITIAL_STATE
  });
}
